<template>
    <div id="libraries-index-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Libraries</h1>

                <div class="table-header" style="margin-bottom:20px;">
                    <div class="table-header__tabs"></div>
                    <div class="table-header__controls">
                        <router-link to="/libraries/create" class="table-header__controls__btn">New Library</router-link>

                        <div class="table-header__controls__search">
                            <SearchBox placeholder="Search"
                                       @search="updateSearchText" />
                        </div>
                    </div>
                </div>

                <DataTable class="libraries-data-table"
                        :dataUrl="dataUrl"
                        :displayId="false"
                        :key="tableRefreshKey"
                        :dataFormatter="formatData"
                        :sortable="true"
                        :filterData="filterData"
                        @actionTriggered="actionTriggered">

                    <template v-slot:empty>
                        No records found
                    </template>
                </DataTable>

            </section>
        </div>
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'
const endpoint = process.env.VUE_APP_API_BASE + '/libraries'
import axios from 'axios'
import SearchBox from "@/components/global/SearchBox.vue";

export default {
    name: 'LibrariesIndex',
    components: {
        SearchBox,
        DataTable
    },
    data: function() {
        return {
            dataUrl: endpoint,
            tableRefreshKey: null,
            filterData: {}
        }
    },
    methods: {
        updateSearchText(query) {
            if (!query || query === '') {
                this.filterData['*'] = undefined
            }
            else {
                this.filterData['*'] = query
            }
        },
        formatData(data) {
            const newData = []
            for (let obj of data) {
                const newObj = {}
                const columns = ['_id', 'name', 'software', 'level', 'brand', 'size', 'skus', 'tags', 'isPrivate', 'createdAt', 'updatedAt']

                for (let key of columns) {
                    if (key === 'brand') {
                        newObj[key] = {
                            'label': key,
                            'value': obj.brand?.name,
                            'display_type': 'text'
                        }
                    }
                    else if (key === 'size') {
                        newObj[key] = {
                            'label': key,
                            'value': parseFloat(obj.size).toFixed(2) + ' MB',
                            'display_type': 'text'
                        }
                    }
                    else if (key.includes('At')) {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'date'
                        }
                    }
                    else if (key === 'skus' || key === 'tags') {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'array'
                        }
                    }
                    else if (key === 'isPrivate') {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key] ? 'PRIVATE' : 'PUBLIC',
                            'display_type': 'text'
                        }
                    }
                    else {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'text'
                        }
                    }
                }

                const actions = {
                    'edit': `<i class="edit-user-action" title="Edit">Edit</i>`,
                    'delete': `<i class="delete-user-action" title="Delete">Delete</i>`
                }
                newObj['actions'] = {
                    'label': '',
                    'value': actions,
                    'display_type': 'actions'
                }

                //const newObjOrdered = Object.assign({'image': ''}, newObj)
                newData.push(newObj)
            }
            return newData
        },
        actionTriggered(actionKey, identifier) {
            if (!identifier) {
                alert('Error occurred #89')
            }
            else if (actionKey == 'edit') {
                this.$router.push('/libraries/' + identifier)
            }
            else if (actionKey == 'delete') {
                if (confirm('Are you sure you want to delete this library?')) {
                    axios.delete(endpoint + '/' + identifier)
                        .then(response => {
                            if (response.data.success === true) {
                                this.tableRefreshKey = Date.now()
                            }
                            else {
                              alert('Error occurred')
                              console.log(response.data.data)
                            }
                        })
                        .catch(error => {
                            alert('Error occurred while deleting')
                            console.log(error)
                        })
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
</style>
